import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import VerifyEmailStep from "./steps/verify-email-step.vue";
import FireImportStep from "./steps/fire-import-step.vue";
import MissingDetailsStep from "./steps/missing-details-step.vue";
import { SHOULD_VERIFY_IMPORT_EMAIL } from "../../store/applications-list-getters";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { showToast } from "@Shared/@Utils/constants";
import { LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { IMPORT_FILOGIX_APPLICATIONS, VERIFY_IMPORT_EMAIL } from "../../store/applications-list-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import Loader from "@Shared/components/modals/generic-modal-loaders/default-body-loader.vue";
import { validationMixin } from "vuelidate";
import { requiredIf, minLength } from "vuelidate/lib/validators";
import { MARK_VERIFICATION_FOR_IMPORT } from "../../store/applications-list-mutations";
import { MISSING_FILOGIX_DETAILS_FOR_IMPORT } from "@Broker/@Modules/settings/store/settings-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ImportClientsModal",
  components: {
    GenericModal,
    VerifyEmailStep,
    FireImportStep,
    MissingDetailsStep,
    SimpleButton,
    Loader
  },
  mixins: [validationMixin],
  validations() {
    return {
      filogixDetailsLocal: {
        firmCode: {
          required: requiredIf(function () {
            return this.currentStep === "missingDetails";
          })
        },
        expertLoginId: {
          required: requiredIf(function () {
            return this.currentStep === "missingDetails";
          })
        },
        expertProfileNumber: {
          required: requiredIf(function () {
            return this.currentStep === "missingDetails";
          })
        }
      },
      verificationCode: {
        required: requiredIf(function () {
          return this.currentStep === "verify";
        })
      },
      expertDealId: {
        required: requiredIf(function () {
          return this.selectedImportType === "single-deal";
        }),
        minLength: minLength(this.selectedImportType === "single-deal" ? 6 : 0)
      },
      startDate: {
        required: requiredIf(function () {
          return this.selectedImportType === "date-range";
        })
      },
      endDate: {
        required: requiredIf(function () {
          return this.selectedImportType === "date-range";
        })
      },
      statusList: {
        required: requiredIf(function () {
          return this.filterByStatus;
        }),
        minLength: minLength(1)
      }
    };
  },
  data() {
    return {
      currentStep: "import",
      loading: true,
      filogixDetailsLocal: {},
      verificationCode: "",
      submit: {
        loading: false,
        loadingSucceeded: true
      },
      expertDealId: null,
      selectedImportType: null,
      startDate: null,
      endDate: null,
      filterByStatus: false,
      statusList: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationsListStore", [SHOULD_VERIFY_IMPORT_EMAIL])), mapState("SettingsStore", {
    filogixDetails(state) {
      return state.filogixDetails;
    }
  })), mapGetters("SettingsStore", [MISSING_FILOGIX_DETAILS_FOR_IMPORT])), {}, {
    missingFilogixDetailsForImport() {
      return this.MISSING_FILOGIX_DETAILS_FOR_IMPORT;
    },
    stepMapping() {
      return {
        import: "FireImportStep",
        verify: "VerifyEmailStep",
        missingDetails: "MissingDetailsStep"
      };
    },
    currentComponent() {
      return this.stepMapping[this.currentStep];
    },
    actionButtonText() {
      const textMap = {
        import: this.$t("application.actions.import.submitImportButtonText"),
        verify: this.$t("application.actions.import.verifyImportButtonText"),
        missingDetails: this.$t("application.actions.import.submitDetailsButtonText")
      };
      return textMap[this.currentStep];
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS])), mapMutations("ApplicationsListStore", [MARK_VERIFICATION_FOR_IMPORT])), mapActions("ApplicationsListStore", [IMPORT_FILOGIX_APPLICATIONS, VERIFY_IMPORT_EMAIL])), {}, {
    async init() {
      this.loading = true;
      await this.LOAD_FILOGIX_DETAILS();
      this.filogixDetailsLocal = this.filogixDetails;
      if (this.missingFilogixDetailsForImport) this.currentStep = "missingDetails";
      this.loading = false;
    },
    handleShow() {
      this.init();
    },
    handleHidden() {
      this.loading = false;
      this.currentStep = "import";
      this.verificationCode = "";
      this.submit.loading = false;
      this.submit.loadingSucceeded = true;
      this.expertDealId = null;
      this.selectedImportType = null;
      this.startDate = null;
      this.endDate = null;
      this.MARK_VERIFICATION_FOR_IMPORT({
        emailVerification: "",
        shouldVerify: false
      });
    },
    async handleImportSubmit() {
      this.submit.loading = true;
      try {
        if (this.currentStep === "missingDetails") {
          await this.updateFilogixDetails(this.filogixDetailsLocal);
        } else if (this.currentStep === "verify") {
          // successfully verifying the email will trigger the import,
          // no need to call import again
          await this.verifyEmailConformation(this.verificationCode, this.expertDealId, this.startDate, this.endDate);
          this.notifyImportSuccess();
        } else {
          await this.triggerImportApplication();
        }
        this.submit.loadingSucceeded = true;
      } catch (e) {
        Amplitude.logHandledError(e);
        this.submit.loadingSucceeded = false;
      } finally {
        this.submit.loading = false;
      }
    },
    async triggerImportApplication() {
      const response = await this.IMPORT_FILOGIX_APPLICATIONS({
        expertDealId: this.expertDealId,
        startDate: this.startDate,
        endDate: this.endDate,
        statusList: this.statusList
      });
      if (!response || response != null && response.shouldVerify) throw "error";
      this.notifyImportSuccess();
    },
    notifyImportSuccess() {
      showToast("success", "importHasBegunMessage");
      this.$hideModal();
    },
    async updateFilogixDetails(filogixDetails) {
      return this.UPDATE_FILOGIX_DETAILS(filogixDetails);
    },
    async verifyEmailConformation(code, expertDealId, startDate, endDate) {
      return this.VERIFY_IMPORT_EMAIL({
        code,
        expertDealId,
        startDate,
        endDate
      });
    },
    goToNextStep() {
      if (this.currentStep === "import" && this.SHOULD_VERIFY_IMPORT_EMAIL) this.currentStep = "verify";
      if (this.currentStep === "missingDetails") this.currentStep = "import";
    }
  })
});